/*
 InfoManager Module

 */


const InfoManager = (function() {
    // ================== VARIABLE ================== //
    var _translation = {};
    var _apiUrls;

    // ================== CONSTRUCTOR ================== //
    function InfoManager() {
        // Singleton
        if (InfoManager.instance) {
            throw new Error('InfoManager is a singleton. Use InfoManager.instance.');
        }
        // enforces new
        if (!(this instanceof InfoManager)) {
            return new InfoManager();
        }
    };

    // ================== PUBLIC METHOD ================== //
    InfoManager.prototype.renderInfos = function(data) {
        $("#h1-container").html(_h1(data));
        $("#other-result-span-type").html(_translation['other_result_' + (data.sharing_type == 'private' ? 'shared' : 'private')]);
        _renderArianeString(data.destination);

        if (data.destination != "" && data.destination != undefined) {

            _renderTrendingDestinations(data.destination.trending_destinations)

            if(data.destination.seo_title) {
                document.title =  data.destination.seo_title
            } else {

            }

            if(data.destination.seo_description) {
               $("meta[name='description']").attr("content", data.destination.seo_description);
            } else {

            }

            if(data.destination.top_activity_info || data.destination.witch_activity_info || data.destination.best_activity_info  || data.destination.advice_info) {
              if(data.destination.top_activity_info) {
                _renderCruiseAdvice('top', data.destination.top_activity_info);
              } else {
                $('#top-activity').hide();
              }
              $('.activity-destination').html(data.destination.name + ' : ');
              if(data.destination.witch_activity_info) {
                _renderCruiseAdvice('witch', data.destination.witch_activity_info);
              } else {
                $('#witch-activity').hide();                
              }
              if(data.destination.best_activity_info) {
                _renderCruiseAdvice('best', data.destination.best_activity_info);
              } else {
                $('#best-activity').hide(); 
              }
              if(data.destination.advice_info) {
                _renderCruiseAdvice('advice', data.destination.advice_info);
              } else {
                $('#advice-activity').hide();
              }
            } else {
                $('#top-activity').hide();
                $('#witch-activity').hide();
                $('#best-activity').hide();
                $('#advice-activity').hide();
            }
        } else {
            $('#top-activity').hide();
            $('#witch-activity').hide();
            $('#best-activity').hide(); 
            $('#advice-activity').hide();  
        }
        $(".private_count").html(data.counter.private);
        $(".shared_count").html(data.counter.shared);
        if (data.count != 0) {
            $(".no-result").hide();
            $(".ordering-filter").show();
        }
        else {
            $(".no-result").show();
            $(".ordering-filter").hide();
        }
    };

    InfoManager.prototype.seti18nParam = function(data) {
        for (var key in data) {
            if (key != 'destination')
                _translation[key] = data[key];
            else
                _translation[key] = data[key].split('destination');
        }
    };

    InfoManager.prototype.setApiUrl = function(urls) {
        _apiUrls = urls;
    };

    // ================== PRIVATE METHOD ================== //
    function _h1(data) {
        if (data.destination != undefined)
            var p1 = data.destination.name + ' : ';
        else
            var p1 = '';
        if (data.count != 0) {
            if(data.count == 1)
                var s_type = _translation['count_' + data.sharing_type]
            else
                var s_type = _translation['count_' + data.sharing_type + '_plural']
            var p2 = data.count + s_type
            if(_translation['info_' + data.sharing_type]) {
              var p3 = ' <span class="subtitle">' + _translation['info_' + data.sharing_type] + '</span>'
            } else {
              var p3 = '';
            }
            return '<h1 id="h1-title" class="search-title d-none d-sm-block">' + p1 + p2 + '</h1>' + p3;
        } else {
            var result = '<h1 id="h1-title" class="search-title d-none d-sm-block">' + p1 + _translation['no_result_h1'] + '</h1>';
            result += '<p>' + _translation['no_result_p'] + '</p>';
            return result;
        }
    }

    function _renderArianeString(destination) {
        if (destination != undefined) {
            var url = _apiUrls['ariane-string'] + destination.pk + '/';
            $.get(url, function(data) {
                var result = '<div class="search-content-separator"></div>';
                var location;
                for (var i = 0; i < data.parent_list.length; i++) {
                    location = data.parent_list[i];
                    result += '<a href="' + location.url + '">' + location.name + '</a>' + (i < (data.parent_list.length-1) ? ' > ' : '');
                };
                $(".ariane-field").html(result);
            });
        } else {
            $(".ariane-field").html('');
        }
    }

    function _renderCruiseAdvice(type, info) {
        if (info == "" || info == undefined) {
            $('#' + type + '-activity').hide();
        } else if (type == 'advice') {
            $('#' + type + '-activity').show();
            $('#' + type + '-activity .intro').html(info);
        } else if (type == 'top') {
            $('#' + type + '-activity').show();
            $('#' + type + '-activity p').html(info);
        } else {
            $('#' + type + '-activity').show();
            $('#' + type + '-activity .intro').html(info.intro);
            $('#' + type + '-activity ul').html(info.list);
        }
    }

    function _renderTrendingDestinations(trending_destinations) {
        let str = '<p><span class="d-none d-sm-inline">' + trending_destinations.label + '</span>'
        let classes = ''
        let items = trending_destinations.destinations
        for(let i=0; i < items.length; i++){
            if (i == 0)
                classes += 'ml-sm-3'
            if (i != items.length)
                classes += ' mr-3'
            str += '<a class="'+ classes +'" href="'+items[i][0]+'?'+window.location.search.substring(1)+'">'+items[i][1]+'</a>'
        }
        str += '</p>'
        $('#trending-destinations').html(str)
    }

    InfoManager.instance = new InfoManager();

    return InfoManager.instance;
})();

export default InfoManager


// WEBPACK FOOTER //
// ./search/static/search/js/infoManager.js